// src/api/axiosInstance.js
import axios from 'axios';
import getApiUrl from '../config/getApiUrl';

const instance = axios.create({
  headers: {
    'Content-Type': 'application/json',  // ← esto es esencial
  },
  withCredentials: true,
});

instance.defaults.headers.post['Content-Type'] = 'application/json';
instance.defaults.headers.put['Content-Type'] = 'application/json';
instance.defaults.withCredentials = true;

instance.interceptors.request.use(config => {
  // Solo si la URL no es absoluta (ya tiene http:// o /api/... )
  if (typeof config.url === 'string' && !config.url.startsWith('http')) {
    config.url = getApiUrl(config.url);
  }

  return config;
}, error => Promise.reject(error));

export default instance;
